import formatUSMonthDayYearDate from './formatUSMonthDayYearDate'
import parseISODate from './parseISODate'

const formatUSMonthDayYearDateString = (dateString) =>
  formatUSMonthDayYearDate(parseISODate(dateString))

export default formatUSMonthDayYearDateString
